export default __webpack_public_path__ + "static/media/cryptopaylogo.a1b44e31.svg";